module.exports = __webpack_public_path__ + "static/media/pickled_tomatoes_680_gr.cd2f2fc0.png";